import { ResponseType } from "../../../Types/ServicesType/servicesType";
import {  MasterDataType, MasterTableDataType, SaveResponseType, SearchParamsType } from "./types";
import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import instance from "@services/services";
const {clinicId} = getConstants()
const {MastersApi} = api
export const getMastersTableData = async (params:SearchParamsType):Promise<ResponseType<{items:MasterTableDataType[],totalCount:number}>>=>{
    const result = await instance.post(`${MastersApi.getAllManagement}`,{...params,clinicId});
    return result.data;
}




export const saveMasterData = async (params:MasterDataType[]):Promise<ResponseType<SaveResponseType>>=>{
    const result = await instance.post(`${MastersApi.saveManagement}`,params);
    return result.data;
}

export const deleteMasterData = async (id:number):Promise<ResponseType<SaveResponseType>>=>{
    const result = await instance.delete(`${MastersApi.deleteInsuranceType}${id}`);
    return result.data;
}
export const getManagementType = async ():Promise<ResponseType<{name:string,id:string}[]>>=>{
    const result = await instance.get(`${MastersApi.getMnageMentType}${clinicId}`);
    return result.data;
}

